import { AppSettings } from '../services/directus/directusClient';
import { THEME_DEFAULTS } from '../constants/themeDefaults';

export const applyBranding = (settings: AppSettings | null): void => {
  const appName = settings?.app_name || THEME_DEFAULTS.APP_NAME;
  const logoUrl = settings?.logo || THEME_DEFAULTS.LOGO_PATH;

  document.title = appName;

  let favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement | null;
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.head.appendChild(favicon);
  }

  if (logoUrl) {
    favicon.href = logoUrl;
  }
};
